import React, { useState } from "react";
import { Table } from "antd";
import { computeRowsAndColsForTransactions } from "../../utils/functions";
import { FleetTransactions } from "pages/fleet/Fleet";
import useWindowDimensions from "common/functions";

interface ITable {
	data: FleetTransactions
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
}

const FleetsTransactionsTable: React.FC<ITable> = ({
	data,
	offset,
	setOffset,
	limit,
	length
}) => {

	const { columns, rows } = computeRowsAndColsForTransactions(
		data,
	);

	const {width} = useWindowDimensions();

	return (
		<Table columns={columns} dataSource={rows} size={width > 1600 ? 'large' : (width > 1200 ? 'middle' : 'small')}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: limit,
				showSizeChanger: false
			}}
			bordered />
	);
};

export default FleetsTransactionsTable;
